import React from "react";
import {
  FaFacebook,
  FaYoutube,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import "../Footer2/Footer2.css";
import { Link } from "react-router-dom";

const callAdmin = () => {
  window.location.href = "tel:+1234567890"; // Calls on mobile
};
const Footer2 = () => {
  return (
    <footer className="footer2">
      <div className="join-section">
        <div className="join-content">
          <h1 className="join-heading" data-aos="fade-down">
            Get Professional Packaging
          </h1>
          <p className="join-subtext" data-aos="fade-down">
            Secure. Sterile. Reliable.
          </p>
          <button
            className="join-button"
            data-aos="flip-up"
            onClick={callAdmin}
          >
            Contact to Get Your Service
          </button>
        </div>
      </div>

      {/* Footer Main */}
      <div className="footer2-main">
        <div className="footer2-left">
          <img src="/logo.webp" alt="OrthoPack Logo" className="footer2-logo" />
        </div>
        <div className="fo">
          <p>© {new Date().getFullYear()} OrthoPack Solutions</p>
          <div className="footer2-center">
            <Link to="/">Home</Link>
            <Link to="/aboutus">About</Link>
            <Link to="/services">Services</Link>
            <Link to="/contactus">Contact</Link>
          </div>
        </div>
        <div className="footer2-right">
          <a href="#facebook" className="social-icon">
            <FaFacebook />
          </a>
          <a href="#twitter" className="social-icon">
            <FaXTwitter />
          </a>
          <a href="#instagram" className="social-icon">
            <FaInstagram />
          </a>
          <a href="#linkedin" className="social-icon">
            <FaLinkedin />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer2;
